module.exports = __webpack_public_path__ + "img/balloon.0a4fac5.svg";